module.exports = __webpack_public_path__ + "mo/img/piece-07.cbe37542.svg";